import { IBiePlanningContext } from './bieprofile.models';

export const requirePlanningCycle = (context?: IBiePlanningContext | null) => {
  if (!context?.pci) {
    return {
      ready: false,
      planningCycleId: null,
      message: 'Open a Planning Cycle before continuing with this workbench.',
    };
  }

  return { ready: true, planningCycleId: context.pci, message: '' };
};
